import { Component, ElementRef, OnInit, OnChanges, SimpleChanges, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit, OnChanges {

  modalRef: NgbModalRef = null;
  modalConfigs: NgbModalOptions = { size: "sm", centered: true, backdrop: 'static', keyboard: false};
  @ViewChild('modalElmRef', { static: false }) modalElmRef!: ElementRef;

  @Input() showModal: boolean = false;
  @Input() headingText: string = 'Confirmation';
  @Input() isHtmlBody: boolean = false;
  @Input() bodyContent: string = 'Are you sure you want to change the status?';
  @Input() showCancel: boolean = true;
  @Input() showConfirm: boolean = true; 
  @Input() cancelText: string = 'Cancel';
  @Input() confirmText: string = 'Yes';
  @Input() cancelBtnClasses: string = 'btn-primary-border';
  @Input() confirmBtnClasses: string = 'btn-primary';

  @Output() statusEmitter: EventEmitter<{status: string}> = new EventEmitter();  

  constructor(private modalService: NgbModal, private sanitizer: DomSanitizer) { }

  /**
   * To initialize data.
   */
  ngOnInit() {}

  /**
   * To open modal if show modal true.
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes['showModal'] && changes['showModal'].currentValue === true) {
      this.openModel();
    }
  }

  /**
   * To open modal popup.
   */
  openModel() {
    setTimeout(() => {
      this.modalRef = this.modalService.open(this.modalElmRef, this.modalConfigs);
    }, 100);
  }

  /**
   * To close modal popup.
   */
  closeModel() {
    this.statusEmitter.emit({ status: 'closed' });
    this.modalRef.close();
  }

  /**
   * On cancel modal popup.
   */
  onCancel() {
    this.statusEmitter.emit({ status: 'cancelled' });
    this.modalRef.close();
  }

  /**
   * On confirm modal popup.
   */
  onConfirm() {
    this.statusEmitter.emit({ status: 'confirmed' });
    this.modalRef.close();
  }
}
